import { useEffect, useState, useRef, useLayoutEffect } from "react";
import React from 'react';
import jibcLogo from '../../assets/jibc_logo_nobackground.png'
import newchat from "../../assets/icon_newchat.png";
import newchatDark from "../../assets/icon_newchat_dark.png";
import stageexp from "../../assets/icon_stageexp.png";
import stageexpDark from "../../assets/icon_stageexp_dark.png";
import ChatHistory from "../chatHistory/ChatHistory";
import { useSelector, useDispatch } from 'react-redux'
import { selectCurrentPage, setCurrPage } from '../../slices/sideBarSlice'
import { selectChats } from '../../slices/chatSlice'
import { setCurrChat } from "../../slices/currChatSlice"
import ChatSession from "../../models/ChatSession";
import { addChatToDB, loadChatFromDB } from '../../slices/chatThunk'
import { v4 as uuidv4 } from 'uuid'

export default function SideBar() {
    const dispatch = useDispatch();

    const containerRef = useRef(null);
    const chatHistoryRef = useRef(null);
    const [containerHeight, setContainerHeight] = useState(0);

    const currPage = useSelector(selectCurrentPage);
    const chats = useSelector(selectChats);

    useLayoutEffect(() => {
        console.log('useLayoutEffect triggered');
        const timer = setTimeout(() => {
            if (chatHistoryRef.current) {
                console.log("Height:", chatHistoryRef.current.offsetHeight);
                setContainerHeight(chatHistoryRef.current.offsetHeight);
            }
          }, 100); // Adjust timing as needed
        
          return () => clearTimeout(timer);
      }, []);

    useEffect(() => {
        console.log("see containerHeight: ", containerHeight)
    }, [containerHeight])

    const newChat = () => {
        const chatSession = new ChatSession(uuidv4()).toPlainObject();
        dispatch(addChatToDB(chatSession));
        dispatch(setCurrChat(chatSession));
        containerRef.current.scrollTop = containerRef.current.scrollHeight;
    };

    const showInprogressChat = chats.filter(chat => chat.completed === false).length !== 0
    const showCompleteChat = chats.filter(chat => chat.completed === true).length !== 0

    // Load chat history in the side bar
    useEffect(() => {
        dispatch(loadChatFromDB())
    }, []);

    useEffect(() => {
        if (currPage === 'newchat') {
            newChat();
        }
    }, [currPage]);


    return (
        <div className={`flex flex-col h-screen bg-[#333333] absolute top-0 lg:left-0 w-80 right-0 z-10`}>
            {/* Title */}
            <div className="flex">
                <button onClick={() => dispatch(setCurrPage('welcome'))} className="m-6 font-bold text-2xl hidden lg:block text-[#1993D6] font-calibri">
                    Chat IT Out
                </button>

                <a href="https://www.jibc.ca/" target="_blank" rel="noopener noreferrer" >
                    <img src={jibcLogo} className="lg:-ml-6 mt-2 w-36 h-16 lg:w-40 lg:h-16" alt="JIBC Logo" />
                </a>
            </div>

            {/* Divider */}
            <hr className="my-3 bg-[#eeeeee] opacity-20" />


            <div className="mt-0">
                {/* New Chat */}
                <div className='flex w-full h-fit p-1.5 mt-6 py-2 hover:bg-[#1e1e1e] rounded-lg'>
                    <button onClick={() => newChat()} className="flex items-center ml-5 font-normal text-base text-white font-calibri">
                        <img src={newchat} className={`square-full mr-3 w-4 h-4 block`} alt="New Chat Icon" />
                        <span>New Chat</span>
                    </button>
                </div>

                {/* What are 5 stages? */}
                <div
                    className={`flex w-full h-fit p-1.5 mt-2 py-2 hover:bg-[#1e1e1e] rounded-lg ${(currPage === "stageexp") ? 'bg-[#1e1e1e] rounded-lg shadow-lg border-2 border-[#0c496b]' : ''
                        }`}
                >
                    <button onClick={() => dispatch(setCurrPage('stageexp'))} className="flex items-center ml-5 font-normal text-base text-white font-calibri">
                        <img src={stageexp} className={`square-full mr-3 w-4 h-4 block`} alt="Stage Icon" />
                        <span>What are the 5 stages?</span>
                    </button>
                </div>
            </div>


            {/* In Progress */}
            <div className={`${showInprogressChat ? 'visible' : 'invisible'} flex flex-col ml-6 mt-10 font-normal text-base leading-5 text-[#ababad] text-opacity-80 font-calibri`}>
                In Progress
            </div>

            <div className="pt-3 max-h-[180px] overflow-y-auto custom-scrollbar" ref={containerRef}>
                {chats
                    .filter(chat => chat.completed === false)
                    .map((chat, index) =>  <ChatHistory key={chat.time} sessionId={chat.sessionId} ref={index === 0 ? chatHistoryRef : null} />)}
            </div>


            {/* Completed */}
            <div className={`${showCompleteChat ? 'visible' : 'invisible'} flex flex-col ml-6 mt-8 font-normal text-base leading-5 text-[#ababad] text-opacity-80 font-calibri`}>
                Completed
            </div>
            
            <div className="pt-3 max-h-[200px] overflow-y-auto custom-scrollbar">
                {chats
                    .filter(chat => chat.completed === true)
                    .map(chat => <ChatHistory key={chat.time} sessionId={chat.sessionId} />
                )}
            </div>

            <div className="absolute bottom-5 left-3 w-11/12 mx-auto">
                {/* Divider */}
                <hr className="my-3 bg-[#eeeeee] opacity-20" />

                <div className={`block w-full h-fit p-2 hover:bg-[#1e1e1e] rounded-lg`}>
                    <a href="https://www.jibc.ca/areas-of-study/conflict-resolution/conflict-resolution-course-calendar" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="block font-normal text-base leading-7 text-white font-calibri">
                        <p>Explore Conflict Resolution Courses</p>
                    </a>
                </div>

                
                {/* Menu items */}
                <div className={`block w-full h-fit p-2 hover:bg-[#1e1e1e] rounded-lg ${currPage === "useterms" ? 'bg-[#1e1e1e] rounded-lg shadow-lg border-2 border-[#0c496b]' : ''}`}>
                    <button onClick={() => dispatch(setCurrPage('useterms'))} className="ml-0 font-normal text-base leading-7 text-white font-calibri">
                        Privacy Statement
                    </button>
                </div>
            </div>
        </div>
    )
}